import { dataPencil } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPencil = /*#__PURE__*/createIcon(dataPencil)
export default IconPencil
